import { EmptyState, Link, WarningIcon } from '@buffer-mono/popcorn'

import styles from './ChartErrorState.module.css'
import type { JSX } from 'react'
interface ChartErrorStateProps {
  size?: 'small' | 'medium'
}

export function ChartErrorState({
  size = 'small',
}: ChartErrorStateProps): JSX.Element {
  return (
    <EmptyState variant="warning" size={size} className={styles.emptyState}>
      <EmptyState.Icon>
        <WarningIcon />
      </EmptyState.Icon>
      <EmptyState.Description>
        We couldn&apos;t load this chart right now.
      </EmptyState.Description>
      <EmptyState.Description>
        Please{' '}
        <Link as="button" onClick={() => window.location.reload()}>
          refresh this page
        </Link>
        .
      </EmptyState.Description>
    </EmptyState>
  )
}
